//export const URL_API = 'http://www.pregrado.unal.edu.co/pruebas/rutas/';
export const URL_API = 'http://www.sae.unal.edu.co/rutas_admin/';



// WEBPACK FOOTER //
// ./src/app/app.constants.ts